/**
 * Set up a single destination trigger
 * @param {HTMLElement} trigger
 * @param {Boolean} isMap
 */
function setupDestinationTrigger(trigger, options) {
  const target = trigger.getAttribute('data-target');
  const {
    isMap = false,
    triggerActiveClass = 'active',
    classToTrigger = 'c-side-block--show',
    initiallySelected = null,
    media = '(min-width: 1024px)',
  } = { ...options };

  function eventHandler() {
    if (window.matchMedia(media).matches) {
      const targetElement = document.querySelector(`#${target}`);

      if (targetElement) {
        const targetClasses = targetElement.classList;

        const allOtherInstances = document.querySelectorAll(
          `.${classToTrigger}`
        );

        Array.from(allOtherInstances).forEach((other) => {
          other.classList.remove(classToTrigger);
        });

        const allTriggers = Array.from(
          document.querySelectorAll('[data-target]')
        );

        allTriggers.forEach((destinationTrigger) => {
          destinationTrigger.classList.remove(triggerActiveClass);

          if (destinationTrigger.dataset.target === trigger.dataset.target) {
            destinationTrigger.classList.add(triggerActiveClass);
          }
        });

        // trigger.classList.add(triggerActiveClass);

        targetClasses.add(classToTrigger);
      }
    }
  }

  const delay = (el, callback) => {
    let timeout = null;

    el.addEventListener('mouseover', () => {
      // Invoke callback after you've hovered for a bit
      timeout = setTimeout(callback, 250);
    });

    el.addEventListener('mouseout', () => {
      clearTimeout(timeout);
    });
  };

  delay(trigger, eventHandler);

  if (isMap) {
    trigger.addEventListener('click', (ev) => {
      ev.preventDefault();
      window.location.href = `/destinations/${target}`;
    });
  }

  if (initiallySelected && initiallySelected === target) {
    eventHandler();
  }
}

/**
 * Set up destination triggers
 */
export function setupDestinations() {
  const destinations = document.querySelector('.js-destinations') || false;

  if (destinations) {
    const map = destinations.querySelector('.js-destinations-map');
    const mapTriggers = Array.from(map.querySelectorAll('[data-target]'));
    const mainTriggers = Array.from(
      destinations.querySelectorAll('.js-destination-trigger')
    );

    mainTriggers.forEach((mainTrigger) =>
      setupDestinationTrigger(mainTrigger, {
        initiallySelected: 'antarctica',
      })
    );
    mapTriggers.forEach((mapTrigger) =>
      setupDestinationTrigger(mapTrigger, {
        isMap: true,
      })
    );
  }
}

export default { setupDestinations };
